<top-nav></top-nav>
<!-- <top-nav-dynamic></top-nav-dynamic> -->
<!-- <header></header>  -->
<router-outlet></router-outlet>
<div id="psPar" class="outside-page"></div>
<back-to-top></back-to-top>
<footer></footer>